export const confirmationSVG = {
  draft: (
    <svg width={64} height={64} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32 0.25C49.535 0.25 63.75 14.465 63.75 32C63.75 49.535 49.535 63.75 32 63.75C14.465 63.75 0.25 49.535 0.25 32C0.25 14.465 14.465 0.25 32 0.25Z"
        stroke="url(#paint0_linear_0_1)"
        strokeWidth="0.5"
      />
      <g clipPath="url(#clip0_0_1)">
        <path
          d="M26.8269 37.8L43.7769 20.85C44.1769 20.45 44.6436 20.25 45.1769 20.25C45.7103 20.25 46.1769 20.45 46.5769 20.85C46.9769 21.25 47.1769 21.7253 47.1769 22.276C47.1769 22.8267 46.9769 23.3013 46.5769 23.7L28.2269 42.1C27.8269 42.5 27.3603 42.7 26.8269 42.7C26.2936 42.7 25.8269 42.5 25.4269 42.1L16.8269 33.5C16.4269 33.1 16.2349 32.6253 16.2509 32.076C16.2669 31.5267 16.4756 31.0513 16.8769 30.65C17.2783 30.2487 17.7536 30.0487 18.3029 30.05C18.8523 30.0513 19.3269 30.2513 19.7269 30.65L26.8269 37.8Z"
          fill="#04051B"
        />
        <path
          d="M26.8269 37.8L43.7769 20.85C44.1769 20.45 44.6436 20.25 45.1769 20.25C45.7103 20.25 46.1769 20.45 46.5769 20.85C46.9769 21.25 47.1769 21.7253 47.1769 22.276C47.1769 22.8267 46.9769 23.3013 46.5769 23.7L28.2269 42.1C27.8269 42.5 27.3603 42.7 26.8269 42.7C26.2936 42.7 25.8269 42.5 25.4269 42.1L16.8269 33.5C16.4269 33.1 16.2349 32.6253 16.2509 32.076C16.2669 31.5267 16.4756 31.0513 16.8769 30.65C17.2783 30.2487 17.7536 30.0487 18.3029 30.05C18.8523 30.0513 19.3269 30.2513 19.7269 30.65L26.8269 37.8Z"
          fill="url(#paint1_radial_0_1)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_0_1"
          x1={32}
          y1={0}
          x2={32}
          y2={64}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFA100" />
          <stop offset={1} stopColor="#996100" stopOpacity="0.5" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_0_1"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(27.8991 -12.6281 2.78295 50.0018 18.0127 38.8915)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFEB14" />
          <stop offset={1} stopColor="#FFA100" />
        </radialGradient>
        <clipPath id="clip0_0_1">
          <rect width={31} height={23} fill="white" transform="translate(16.25 20.25)" />
        </clipPath>
      </defs>
    </svg>
  ),
  back: (
    <svg width={12} height={16} viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_13698_4315)">
        <path
          d="M5.99835 2.19922C6.10371 2.19932 6.20871 2.22022 6.30597 2.26074C6.40317 2.30135 6.49253 2.36075 6.56671 2.43555L6.56769 2.43652C6.64247 2.51081 6.70195 2.59996 6.74249 2.69727C6.78297 2.79461 6.80402 2.89946 6.80402 3.00488C6.80398 3.11035 6.78303 3.21514 6.74249 3.3125C6.70199 3.40967 6.64235 3.49805 6.56769 3.57227L6.56671 3.57324L2.92413 7.20508H10.9984C11.2103 7.20526 11.4139 7.28958 11.5638 7.43945C11.7135 7.58944 11.7982 7.79293 11.7982 8.00488C11.7981 8.21685 11.7136 8.42037 11.5638 8.57031C11.4139 8.72016 11.2103 8.80451 10.9984 8.80469H2.92413L6.56671 12.4365C6.71722 12.5873 6.80206 12.7918 6.80206 13.0049C6.80201 13.2179 6.71727 13.4225 6.56671 13.5732C6.41609 13.7238 6.21133 13.8084 5.99835 13.8086C5.89307 13.8086 5.78804 13.7882 5.69073 13.748C5.59338 13.7077 5.50456 13.6477 5.42999 13.5732L0.432921 8.57617C0.360207 8.50021 0.303026 8.41052 0.264953 8.3125L0.263 8.30859C0.183123 8.11403 0.18321 7.89576 0.263 7.70117L0.264953 7.69727C0.302413 7.60072 0.35888 7.51176 0.429992 7.43652L5.42999 2.43555C5.50431 2.36068 5.59336 2.30131 5.69073 2.26074C5.78808 2.22027 5.89292 2.19922 5.99835 2.19922Z"
          fill="white"
          fillOpacity="0.7"
        />
      </g>
      <defs>
        <clipPath id="clip0_13698_4315">
          <rect width={12} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};
